import { Component, OnInit, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MeetingCreateFormComponent } from '../meetings-create/meeting-create-form/meeting-create-form.component';
import { MeetingsService } from 'app/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { isEmpty, pickBy, identity, forEach } from 'lodash';
import { TimeLineDataService } from 'app/components/time-line/time-line-data.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FormArray } from '@angular/forms';
@Component({
    selector: 'app-meeting-create-modal',
    templateUrl: './meeting-create-modal.component.html',
    styleUrls: ['./meeting-create-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MeetingCreateModalComponent implements OnInit {
    data: any;
    @ViewChild(MeetingCreateFormComponent, { static: true }) meetingCreateForm: MeetingCreateFormComponent;
    borderColor: string;
    meeting: FormArray;
    participants: FormArray;
    toggle = false as boolean;
    isClick = false as boolean;
    _id: string;
    ical: any;
    constructor(
        public matDialogRef: MatDialogRef<MeetingCreateModalComponent>,
        private _meetingsService: MeetingsService,
        private _snackBar: MatSnackBar,
        private _translateService: TranslateService,
        private _timeLineData: TimeLineDataService,
        private _fuseSidebarService: FuseSidebarService,
        @Inject(MAT_DIALOG_DATA) public _data: any
    ) {
        /**
         * Here are details about _data format recieving from different components:
         * - open from Calendar (add button)
         * { "realatedTo":"calendar", "date":"current date"}
         * 
         * - open from Calendar (view meeting), Activites tab (meeting sidebar)
         * { "realatedTo":"update", "data":{meeting data}}
         * 
         * - open from Timeline comments (view meeting)
         * { "realatedTo":"update", "_id":id}
         * 
         * - open from Activites tab (add activities button)
         * undefined
         */

        if (!isEmpty(this._data)) {
            this.data = this._data;
            this.borderColor = this.data?.data?.color ? this.data.data.color : this.data?.color;
            this._id = this?.data?.data?._id ? this.data.data._id : this.data?._id;
            if (this.data?.data?.ical) {
                this.ical = this.data.data.ical;
            }
        }
    }
    ngOnInit(): void {
        if (!isEmpty(this.data)) {
            if (this.data.relatedTo === 'update') {
                setTimeout(() => {
                    if (this._id) {
                        this._meetingsService.getById(this._id).subscribe((data: any) => {
                            this.meetingCreateForm.activity.patchValue(data);
                            this.meeting = this.meetingCreateForm.activity.get('meeting') as FormArray;
                            this.participants = this.meetingCreateForm.activity.get('participants') as FormArray;
                            this.meetingCreateForm.clearFormArray(this.meeting);
                            if (data.meeting && data.meeting.length) {
                                forEach(data.meeting, (extra, key) => {
                                    this.meeting.push(this.meetingCreateForm.createMeeting());
                                    this.meetingCreateForm.activity.get('meeting.' + key).patchValue(extra);
                                });
                            } else {
                                this.meeting.push(this.meetingCreateForm.createMeeting());
                            }
                            this.meetingCreateForm.clearFormArray(this.participants);
                            if (data.participants && data.participants.length) {
                                forEach(data.participants, (extra, key) => {
                                    this.participants.push(this.meetingCreateForm.createOpening());
                                    this.meetingCreateForm.activity.get('participants.' + key).patchValue(extra);
                                });
                            } else {
                                this.participants.push(this.meetingCreateForm.createOpening());
                            }
                        });
                    } else {
                        this.meetingCreateForm.activity.patchValue(this.data?.data ? this.data.data : this.data);
                        if (this.ical) {
                            this.meetingCreateForm.viewRecord = this.ical;
                        }
                    }
                }, 200);
            } else if (this.data.relatedTo === 'calendar') {
                setTimeout(() => {
                    this.meetingCreateForm.activity.get('start_date').setValue(this.data.date);
                    this.meetingCreateForm.activity.get('end_date').setValue(this.data.date);
                }, 200);
            } else {
                this._meetingsService.getById(this._id).subscribe((data: any) => {
                    this.meetingCreateForm.activity.patchValue(data);
                    this.participants = this.meetingCreateForm.activity.get('participants') as FormArray;
                    this.meetingCreateForm.clearFormArray(this.participants);
                    if (data.participants && data.participants.length) {
                        forEach(data.participants, (extra, key) => {
                            this.participants.push(this.meetingCreateForm.createOpening());
                            this.meetingCreateForm.activity.get('participants.' + key).patchValue(extra);
                        });
                    } else {
                        this.participants.push(this.meetingCreateForm.createOpening());
                    }
                    this.meetingCreateForm.viewRecord = true;
                });
            }
        }
    }

    submitForm(): void {
        this.isClick = true;
        this.meetingCreateForm.activity.get('type').setValue('meeting');
        if (this.borderColor) {
            this.meetingCreateForm.activity.get('color').setValue(this.borderColor);
        }
        if (!isEmpty(this.data)) {
            if (this.meetingCreateForm.activity.valid) {
                this.meetingCreateForm.activity.get('type').setValue('meeting');

                // update case
                if (this._id) {
                    this._meetingsService.update(this.meetingCreateForm.activity.getRawValue()).subscribe((data: any) => {
                        this.matDialogRef.close('refresh');
                    }, (err) => {
                        this.isClick = false;
                    });
                } else {
                    //create case
                    this._meetingsService.create(this.meetingCreateForm.activity.getRawValue()).subscribe((data: any) => {
                        this.matDialogRef.close('refresh');
                        this._snackBar.open(this._translateService.instant('Created successfully'), this._translateService.instant('Close'), {
                            duration: 2000,
                        });
                    }, (err: any) => {
                        this.isClick = false;
                    });
                }
            } else {
                this.meetingCreateForm.activity.markAllAsTouched();
                this.isClick = false;
            }
        } else {
            this._meetingsService.create(pickBy(this.meetingCreateForm.activity.getRawValue(), identity)).subscribe((data: any) => {
                this.matDialogRef.close();
            }, (err: any) => {
                this.isClick = false;
            });
        }


    }
    onOpenTimeline(event: any): void {
        this._timeLineData.setModelDataValue(event);
        this._timeLineData.setRelatedToValue('activities');
        this._fuseSidebarService.getSidebar('timeline').toggleOpen(1000000);
    }
}
